import request from '@/utils/request'
const requestApi = (metod,url,params, option) => request(metod, url, params, option); // 图书分类

export const serverApi = {
    requestApi,
}



// WEBPACK FOOTER //
// ./src/server/index.js